import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-fzbaureihe-list-view',
  imports: [],
  templateUrl: './fzbaureihe.list-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FzbaureiheListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
